
import {
    Button,
    Box,
    Container,
    Flex,
    Heading,
    Image,
    Stack,
    Text,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Input,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    FormControl,
    FormLabel,
    FormHelperText,
    chakra, useColorModeValue, VisuallyHidden, Link, useToast
} from "@chakra-ui/react";

import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
} from '@chakra-ui/react'

import {Header as Nav} from "../header/Header";
import {Footer} from "../footer/Footer";
import {Form, redirect, useNavigate} from "react-router-dom";
import {FormControlEvo} from "../forms/chakra/FormControlEvo";
import {EmailInputEvo} from "../forms/chakra/inputs/EmailInputEvo";
import React, {useState} from "react";
import Cookies from "js-cookie";
import {useEvoContext} from "../../context/evo.context";
import LoginDataProvider from "../dataProviderEvo/login-data-provider";
import RegisterDataProvider from "../dataProviderEvo/register-data-provider";
import {emptyFormData, fieldNameAndLabels} from "../../infrastructure/utils/formUtils";
import {ScreenContainer} from "../container/ScreenContainer";
import PasswordResetDataProvider from "../dataProviderEvo/password-reset-data-provider";
import {ROUTE_LOGIN, ROUTE_MAIN, ROUTE_PURCHASE_CONFIRMATION_PART} from "../../App";


export default function PasswordReset() {

    const {isLoggedIn, setIsLoggedIn} = useEvoContext();
    const navigate = useNavigate();

    const toast = useToast();

    const [formData, setFormData] = useState(emptyFormData);

    // let fieldNamesAndLabels = fieldNameAndLabels;

    const [errors, setErrors] = useState({ email: '', password: '' });

    const validateForm = () => {
        const newErrors = {};

        let emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = 'Email is invalid';
        }


        setErrors(newErrors);

        // Returns true if no errors found
        return Object.keys(newErrors).length === 0;
    };



    // Handle form input changes
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); // Prevent default form submission

        if (validateForm()) {

            let headers = {
                "email": formData.email
            }

            let params = headers;

            let dp = new PasswordResetDataProvider();
            dp.reset(params, headers).then((res) => {

                if (res.status === 'OK') {
                    toast({
                        description: res.messages[0],
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });

                    navigate(ROUTE_MAIN + ROUTE_LOGIN);

                } else {

                    toast({
                        description: res.errors[0],
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });
                }
            });
        }
    };


    return (
        <Box bg={useColorModeValue('#f9f9f9', '#1a202c')}>
            <Nav />
            <ScreenContainer>
                <Stack direction={{ base: 'column', md: 'column' }}>
                    <Flex flex={1} align={'center'} justify={'center'}>

                        <Stack direction={{base: 'column', md: 'column'}}>
                            <Flex flex={1} align={'center'} justify={'center'}>
                                <Stack spacing={6} w={'full'}>
                                    <chakra.h1 textAlign={'center'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
                                        {"Obnovení hesla"}
                                    </chakra.h1>
                                </Stack>
                            </Flex>

                        </Stack>
                    </Flex>

                </Stack>
                <Box bg={"white"} mt={"5"}  padding={"10"} mt={5} boxShadow={"md"} borderRadius={10}>
                    <Form method={"post"} onSubmit={handleSubmit} >
                        <EmailInputEvo validity={errors.email} defaultVal={formData.email} handleChange={handleChange} />
                        <Stack spacing={3} my={5} alignContent={"center"} alignItems={"center"}>
                            <Text fontSize='1xl'>Po odeslání tohoto formuláře obdržíte e-mail s pokyny k obnovení hesla.
                            </Text>
                        </Stack>
                        <Button colorScheme='pink' variant='solid' type={"submit"}>Zaslat instrukce</Button>
                    </Form>
                </Box>
            </ScreenContainer>
            <Footer />
        </Box>
    )
}


export const createAction = async (req : any) => {
    const data = await req.formData;

    const userData =  {
        email: data.get('e-mail')

    }

    // console.log(userData);

    return redirect('/');
}

